<template>
  <div class="section">
    <div class="container">
      <div class="block mb-4">
        <h1 class="title has-text-centered">FAQ</h1>
        <hr />
      </div>
      <div v-for="topic in topics" :key="topic.id" class="card mb-5">
        <div class="card-content">
          <div class="title">{{ topic.name }}:</div>
          <b-collapse
            v-for="id in topicQuestions[topic.id]"
            :key="id"
            v-model="qFolded[id].$folded"
            animation="slide"
            class="panel is-white mb-4"
            style="box-shadow: none"
          >
            <template #trigger>
              <div
                class="panel-heading is-flex is-align-items-start px-0 pb-1"
                style="color: #4c4c4c"
              >
                <b-icon
                  :icon="qFolded[id].$folded ? 'angle-down' : 'angle-right'"
                  class="mr-3 is-flex-shrink-0"
                ></b-icon>
                <span>
                  {{ qFolded[id].title }}
                </span>
              </div>
            </template>
            <div class="panel-block">
              <div class="content pl-5" v-html="qFolded[id].content"></div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      topics: {
        1: { id: 1, name: 'Allgemeine Fragen' },
        2: { id: 2, name: 'Daten' },
        3: { id: 3, name: 'Funktionalität' },
      },
      questions: {
        1: {
          id: 1,
          title: 'Wie kann ich das Standortmonitor.net Team von Goldmedia kontaktieren?',
          content:
            '<p>Standortmonitor.net wird betrieben von Goldmedia GmbH Strategie Consulting. Bei Fragen und Anregungen erreichen Sie uns jederzeit per <a href="mailto:support@standortmonitor.net?subject=Fragen%20und%20Anregungen">E-Mail</a> oder telefonisch unter der <a href="tel:030-2462660">030-2462660</a>.</p>',
        },
        2: {
          id: 2,
          title:
            'Wie kann ich auf die Daten von Standortmonitor.net zugreifen oder sie abonnieren?',
          content:
            '<p>Um einen Zugang zu den Daten und Analysen von Standortmonitor.net zu erhalten, kontaktieren Sie uns bitte direkt per <a href="mailto:support@standortmonitor.net?subject=Anfrage">E-Mail</a> oder telefonisch unter der <a href="tel:030-2462660">030-2462660</a>. Gerne geben wir Ihnen bei Bedarf einen Einblick in das Produkt und erstellen ein unverbindliches Angebot für Sie.</p>',
        },
        3: {
          id: 3,
          title: 'Wie kann ich mögliche Fehler melden und Ideen bzw. Anmerkungen einreichen?',
          content:
            '<p>Alle Daten und Analysen, die bei Standortmonitor.net abrufbar sind, unterlaufen einem systematischen Kontrollprozess und werden laufend überprüft. Sollte Ihnen dennoch ein Fehler aufgefallen sein oder haben Sie Ideen, Fragen bzw. Anmerkungen, freuen wir uns auf Ihre <a href="mailto:support@standortmonitor.net?subject=Anfrage">Nachricht</a>.</p>',
        },
        4: {
          id: 4,
          title:
            'Darf ich die Grafiken, Analysen und Daten von Standortmonitor.net extern teilen und veröffentlichen?',
          content: `<p>Die Veröffentlichung von ausgewählten Daten, Analysen und Grafiken von Standortmonitor.net ist Kunden jederzeit erlaubt. Voraussetzung ist, dass veröffentlichte Informationen einen direkten geografischen bzw. inhaltlichen Bezug zum Verantwortungsbereich des Kunden aufweisen. Eine eigene kommerzielle Weitervermarktung oder ein vollständiger Download sämtlicher Daten ist nicht gestattet.<p/> 
            <p>Geben Sie bei der Veröffentlichung bitte immer die Quelle entsprechend der jeweiligen Ausführung unter der Grafik bzw. dem Datenexport an.</p>`,
        },
        5: {
          id: 5,
          title: 'Über welche Daten verfügt Standortmonitor.net?',
          content: `<p>Standortmonitor.net bietet visuell optimierte Analysen und detaillierte Auswertungen zu den zentralen Kennzahlen “Beschäftigte”, “Steuerpflichtige” sowie “Lieferungen und Leistungen”. Diese Kennzahlen lassen sich weiter in detailliertere Unterkategorien gliedern.</p> 
          <p>Der Umfang der einzelnen Kennzahlen umfasst sowohl alle Teilmärkte als auch alle Wirtschaftszweige der deutschen Kultur- und Kreativwirtschaft.<p/> 
          <p>Die drei zentralen Kennzahlen liegen ebenfalls auf Bundes- & Länder-Ebene vor. Darüber hinaus bietet der Standortmonitor.net weitere Analysen zu Beschäftigten auf der Land- & Stadtkreis-Ebene an.<p/> Folgende Teilmärkte werden in den jeweiligen Produkten untersucht:
          <ul>
            <li>
              Kultur- und Kreativwirtschaft: <br />
              <ul>
                <li>Architektur</li>
                <li>Buch</li>
                <li>Darstellende Kunst</li>
                <li>Design</li>
                <li>Film</li>
                <li>Kunst</li>
                <li>Musik</li>
                <li>Rundfunk</li>
                <li>Presse</li>
                <li>Software/Games</li>
                <li>Werbung</li>
                <li>Sonstige</li>
                <li>Unordered List Item One</li>
              </ul>
            </li>
            <li>
              Digitalwirtschaft: <br />
              <ul>
                <li>Consumer Electronics</li>
                <li>E-Commerce</li>
                <li>IKT-Basisinfrastruktur</li>
                <li>Software- und Datendienstleister</li>
              </ul>
            </li>
          </ul>`,
        },
        6: {
          id: 6,
          title:
            'Ein für mich relevanter Markt fehlt. Kann ich mir zusätzliche Analysen und/oder separate Teilmärkte zusammenstellen?',
          content: `Mithilfe des Standortmonitor.net lassen sich stets belastbare und aktuelle Daten für alle vom Statistischen Bundesamt (DESTATIS) erfassten 615 Wirtschaftszweig-Klassen in Deutschland flexibel abbilden. <br/> 
          Gerne können wir für Sie eine neue Zusammensetzung von bestehenden WZ-Klassen in neue Teilmärkte vornehmen. So stellt auch die Darstellung weiterer Wirtschaftsbereiche kein Problem dar.`,
        },
        7: {
          id: 7,
          title:
            'Was kann ich tun, wenn die Daten, die ich benötige, nicht richtig angezeigt werden?',
          content: `<p>Sollte der Standortmonitor.net die von Ihnen benötigten Daten aktuell nicht bereitstellen, kann dies verschiedene Gründe haben.<p/> 
            <p>Bitte überprüfen Sie zunächst, ob der gesuchte Teilmarkt bzw. die WZ-Klasse in Ihrem aktuell abonnierten Produktumfang enthalten ist. Eine Übersicht aller in Ihrem Produktumfang enthaltenen WZ-Klassen finden Sie nach Anmeldung unter dem Reiter „Methodik“ unter der Rubrik „Anteilswerte“. Um Zugang zu weiteren Teilmärkten und WZ-Klassen zu erhalten, können Sie uns gern kontaktieren.<p/> 
            <p>Im Standardumfang des Standortmonitor.net sind zudem aktuell auf der Stadt-/Landkreis-Ebene nur Daten zu “Beschäftigten” (inkl. sv-pflichtig und geringfügig Beschäftigter) verfügbar. Aufgrund von DSGVO-konformer Anonymisierung seitens unserer Datenlieferanten entstehen Datenlücken für die Umsatz- und Unternehmenskennzahlen.</p>`,
        },
        8: {
          id: 8,
          title:
            'Weshalb sind auf der Ebene der Stadt- und Landkreise keine Unternehmens- und Umsatzdaten verfügbar?',
          content: `<p>Im Standardumfang des Standortmonitor.net werden aktuell nur die Beschäftigtendaten auf der Stadt-/Landkreis-Ebene ausgewiesen, da zwecks DSGVO-Konformität eine Anonymisierung der Daten durch unsere Datenlieferanten vorgenommen werden muss. So können Datenlücken für die Umsatz- und Unternehmenskennzahlen entstehen.<p/> 
            <p>Existieren beispielsweise nur zwei Buchverlage an einem Standort, werden beide im Datensatz NICHT ausgewiesen, um etwaige Rückschlüsse auf ihre innerbetriebliche Situation zu verhindern.<p/> 
            <p>Sollten Sie dennoch einen Zugang zu den Umsatz- und Unternehmenskennzahlen auf Stadt-/Landkreis-Ebene für Ihr Bundesland wünschen, erstellen wir für Sie gegen Aufpreis auch Sonderanalysen.</p>`,
        },
        9: {
          id: 9,
          title: 'Weshalb weichen die „∑ Summe:“-Werte von den summierten Teilwerten ab?',
          content: `<p>Grund hierfür ist ein sogenannter Doublecounting-Effekt. Dieser Effekt resultiert aus der statistischen Anpassung der Kultur- und Kreativwirtschaftsteilmärkte entsprechend der Beschlüsse des Arbeitskreises „Kulturstatistik e. V.“ (vgl. hierzu: DESTATIS; Arbeitskreis Kulturstatistik e. V., Söndermann (2012) – „Wirtschaftszweigklassifikation WZ 2008“, online unter: <a href="https://www.kulturwirtschaft.de/wp-content/uploads/2011/01/Kurzanleitung-KKW_20120124.pdf">https://www.kulturwirtschaft.de/wp-content/uploads/2011/01/Kurzanleitung-KKW_20120124.pdf</a> letzter Zugriff: 21.12.2020).<p/> 
          <p>Doublecounting bedeutet, dass eine WZ-Klasse doppelt verrechnet wird. So kann eine einzelne WZ-Klasse (bspw. WZ-Klasse „Druckereien“) in mehreren Teilmärkten (bspw. je in Teilmarkt „Buch“ und Teilmarkt „Presse“) vorkommen. Real existieren die Werte einer WZ-Klasse jedoch nur einmal.<p/>
          <p>Entsprechend ist in unserer Gesamtauswertung („∑ Summe:“) diese WZ-Klasse nur einmal enthalten. Die Daten der einzelnen Teilmärkte dürfen daher für eine wahrheitsgemäße Auswertung aufgrund des Doublecounting-Effekts nicht einfach summiert werden.<p /> 
          <p>„∑ Summe:“-Werte stellen somit wahrheitsgemäße Gesamtwerte OHNE Doublecounting dar. Dem gegenüber stehen die summierten Werte aus allen 16 Bundesländern MIT Doublecounting, die höhere Werte ausweisen dürften als bereinigte "∑ Summe:"-Werte.</p>`,
        },
        10: {
          id: 10,
          title: 'Aus welchen Quellen stammen die Daten?',
          content: `<p>Alle Daten und Kennzahlen des Standortmonitor.net stammen aus offiziellen Quellen wie dem Statistischen Bundesamt (DESTATIS), den Statistischen Landesämtern sowie der Bundesagentur für Arbeit.<p/> 
            <p>Um die reale Marktsituation in bestimmten Teilmärkten (bspw. die Gameswirtschaft im eig. Sinne) besser abzubilden, werden in Sonderanalysen auch Daten ausgewählter Branchenverbände verarbeitet.</p>`,
        },
        11: {
          id: 11,
          title: 'Wann werden die Daten aktualisiert?',
          content:
            '<p>Die Daten des Standortmonitor.net werden laufend aktualisiert. Neu publizierte Daten werden nach der Bereitstellung durch unsere Datenlieferanten umgehend integriert.<p/> <p>Die Beschäftigtendaten sind in der Regel ab dem zweiten Quartal des laufenden Kalenderjahres für das Vorjahr verfügbar. Die Umsatz- und Unternehmenskennzahlen werden im vierten Quartal des Kalenderjahres für das jeweils letzte Kalenderjahr ausgewiesen.</p>',
        },
        12: {
          id: 12,
          title: 'Wie finde ich die passenden Daten zu meiner Anfrage?',
          content: `<p>Über die Navigationsleiste auf der linken Bildseite gelangen Sie
                zu den verschiedenen verfügbaren Umsatz-, Unternehmens- und
                Beschäftigtenanalysen. Mittels diverser Filter am oberen
                Bildrand können Sie Ihre Suche weiter verfeinern und bspw. das
                zu betrachtende Jahr, Bundesland oder einen speziellen Teilmarkt
                auswählen.<p/>                
                <p>Mithilfe der angezeigten roten Buttons werden zudem jeder
                Analyse mehrere Schlagworte zugeordnet. Zukünftig wird es
                mithilfe dieser Funktion möglich sein, noch einfacher zu den
                gesuchten Informationen zu gelangen. Wir arbeiten bereits an der
                Integration dieser Funktion.</p>`,
        },
        13: {
          id: 13,
          title: 'Welche Analysefunktionen bietet der Standortmonitor.net?',
          content: `Der Standortmonitor.net bietet zahlreiche Analysefunktionen, die
                in folgende Kategorien unterteilt sind:
                <ol>
                  <li>
                    Standortanalyse: Diese Rubrik bietet Ihnen die Möglichkeit
                    einen Standort Ihrer Wahl in allen seinen Details bis hin
                    zur Landkreisebene zu untersuchen.
                  </li>
                  <li>
                    Zeitreihen: In diesem Abschnitt können Sie Veränderungen der
                    Kennzahlen im Zeitverlauf analysieren.
                  </li>
                  <li>
                    Bundesvergleiche: In diesem Bereich erhalten Sie einen
                    Gesamtüberblick für ausgewählte Teilmärkte und WZ-Klassen
                    auf Bundesebene.
                  </li>
                  <li>
                    Ländervergleiche: Diese Rubrik sollten Sie nutzen, um
                    einzelne Bundesländer gegenüberzustellen und deren
                    Kennzahlen miteinander zu vergleichen.
                  </li>
                  <li>
                    Kreisvergleiche: Ebenfalls haben Sie die Möglichkeit,
                    Kennzahlen einzelner Land- bzw. Stadtkreise sowie Verbünde
                    derer miteinander detailliert zu vergleichen.
                  </li>
                </ol>
                <p>Weiterhin bietet Standortmonitor.net eine Reihe von Analysen, in
                welchen die verfügbaren Kennzahlen in Relation zueinander
                ausgewertet werden können. Sie finden diese Analysen unter dem
                Reiter „Index-Analysen“.<p/>
                <p>Unterhalb der jeweils angezeigten Grafik erhalten Sie darüber
                hinaus eine Auswahl weiterer Analyseoptionen.<p/>
                <p>Sollten Sie eigene Analysen vornehmen wollen, können Sie alle
                Datensätze, welche den angezeigten Darstellungen zugrunde
                liegen, als Excel- oder CSV-Datei herunterladen. Nutzen Sie
                hierfür den „XLSX“-Button über dem Abschnitt „DATENEXPORT“ des
                jeweiligen Dashboards.</p>`,
        },
        14: {
          id: 14,
          title: 'Wie filtere ich Ansichten für meine Anfrage?',
          content: `<p>Zur Beantwortung spezifischer Fragestellungen ist es in vielen
                Fällen nötig, die angezeigten Darstellungen mithilfe der
                verfügbaren Filterfunktionen weiter zu verfeinern.<p/>
                <p>Abhängig von der jeweiligen Darstellung im Dashboard ist es
                möglich</p>
                <ul>
                  <li>Zeitpunkte oder Zeiträume,</li>
                  <li>Bundesländer bzw. Stadt-/Landkreise,</li>
                  <li>Teilmärkte bzw. WZ-Klassen</li>
                </ul>
                <p>auszuwählen, einzugrenzen oder hervorzuheben. Bei dem
                Standortmonitor.net handelt es sich um einen sehr umfangreichen
                Onlineservice, der Ihnen viele hochgradig komplexe Analysen und
                tiefgehende Insights auf Knopfdruck bietet. Achten Sie deswegen
                beim Filtern der Ansicht unbedingt darauf, dass sich die Filter
                nicht gegenseitig widersprechen.<p/>
                <p>Sofern Sie verschiedene Methodiken abonniert haben, wählen Sie
                immer zunächst die gewünschte Methodik aus und filtern Sie die
                Daten anschließend entsprechend ihres Detailgrades. Das heißt,
                Sie sollten zunächst die Oberkategorie wählen (Teilmarkt oder
                Bundesland) und erst anschließend die Unterkategorie (WZ-Klasse
                oder Stadt-/Landkreis). Um die Oberkategorie ändern zu können,
                kann es vorkommen, dass Sie aufgrund der internen Datenbanklogik
                zunächst wieder „(Alle)“ Werte der Unterkategorie auswählen
                müssen, bevor Sie Änderungen der Oberkategorie vornehmen können.<p/>
                <div class="block m-5">
                  <b>Beispiel:</b> Sollte die Ansicht das Filtern nach
                  Teilmärkten und WZ-Klassen erlauben, müssen Sie zunächst den
                  anzuzeigenden Teilmarkt und hiernach die relevanten WZ-Klassen
                  auswählen. Wenn Sie nun zu einem anderen Teilmarkt wechseln
                  möchten, wählen Sie zunächst wieder „(Alle)“-WZ-Klassen aus
                  und ändern dann den Teilmarkt.
                </div>`,
        },
        15: {
          id: 15,
          title: 'Welche Exportfunktionen stehen zur Verfügung?',
          content: `<p>Sie haben die Möglichkeit das gesamte Dashboard im PNG-, PDF-
                und PPT-Format über die entsprechenden roten Buttons zu
                exportieren. Ein direkter Export der einzelnen Diagramme wird
                aktuell durch die zugrundeliegende Analytik-Software Salesforce
                Tableau nicht unterstützt.<p/>
                <p>Alle verfügbaren Datensätze können als Excel- oder CSV-Datei
                exportiert werden. Nutzen Sie hierfür den „XLSX“-Button über dem
                Abschnitt „DATENEXPORT“ des jeweiligen Dashboards.</p>`,
        },
        16: {
          id: 16,
          title: 'Wieso funktioniert der „Zurück“-Button in meinem Webbrowser nicht?',
          content: `Da die Inhalte des Standortmonitors mithilfe der
                Analytik-Software Salesforce Tableau erstellt werden,
                funktionieren einige der Browser-basierten Befehle wie „Zurück“
                nicht. Um zu dem vorherigen Dashboard bzw. auf die Startseite
                zurückzukehren, klicken Sie bitte erneut auf die jeweilige
                Registerkarte in der linken Navigationsleiste.`,
        },
        17: {
          id: 17,
          title: 'Was kann ich tun, wenn es Probleme bei der Darstellung der Inhalte gibt?',
          content: `Probleme bei der Darstellung der Dashboards können aufgrund der
                Auflösung Ihres Monitors entstehen. Standortmonitor.net wurde
                für Monitore mir einer Full-HD-Auflösung (1920 x 1080 Pixel)
                sowie speziell für Tablet-Geräte (1024 x 768 Pixel) optimiert.
                Wenn Sie über eine geringere Auflösung verfügen, können Sie die
                Ansicht mit dem gleichzeitigen Drücken der „STRG“-Taste
                (Windows) oder der „Command“-Taste (Mac) UND dem Scrollen des
                Mausrads nach unten anpassen. Standortmonitor.net ist aktuell
                noch NICHT für Smartphones optimiert.`,
        },
        18: {
          id: 18,
          title:
            'Wo finde ich eine Definition der ausgewiesenen Kennzahlen bzw. eine Übersicht der Zusammensetzung der einzelnen Teilmärkte?',
          content: `Unter dem Reiter „Methodik“ findet sich eine detaillierte
                Erläuterung zu den ausgewiesenen Beschäftigten-, Unternehmens-
                sowie Umsatzkennzahlen. Dort können Sie ebenfalls einsehen, zu
                wieviel Prozent die Gesamtumsätze, -unternehmen und
                -beschäftigten der einzelnen WZ-Klassen der abonnierten Methodik
                zugerechnet werden.`,
        },
      },
      topicQuestions: {
        1: [1, 2, 3, 4],
        2: [5, 6, 7, 8, 9, 10, 11],
        3: [12, 13, 14, 15, 16, 17, 18],
      },
    };
  },
  computed: {
    qFolded() {
      return Object.values(this.questions)
        .map((q) => {
          const qCopy = { ...q };
          qCopy.$folded = false;
          return qCopy;
        })
        .reduce((acc, q) => {
          acc[q.id] = q;
          return acc;
        }, {});
    },
  },
};
</script>
